// Acción de inicio de sesión
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';

// Acciones de carga de autenticación
export const SET_AUTH_LOADING = 'SET_AUTH_LOADING';
export const REMOVE_AUTH_LOADING = 'REMOVE_AUTH_LOADING';

//accion guarda carga token
export const SET_TOKEN = 'SET_TOKEN';

// Acción de cierre de sesión
export const LOGOUT = 'LOGOUT';

// Acción de valida portal
export const VALIDA_PORTAL_REQUEST = 'VALIDA_PORTAL_REQUEST';
export const VALIDA_PORTAL_SUCCESS = 'VALIDA_PORTAL_SUCCESS';
export const VALIDA_PORTAL_FAIL = 'VALIDA_PORTAL_FAIL';

// Acción Trae Combo Servicios
export const COMBO_PROFILE_ESTABLECIMIENTO_REQUEST = 'COMBO_PROFILE_ESTABLECIMIENTO_REQUEST';
export const COMBO_PROFILE_ESTABLECIMIENTO_SUCCESS = 'COMBO_PROFILE_ESTABLECIMIENTO_SUCCESS';
export const COMBO_PROFILE_ESTABLECIMIENTO_FAIL = 'COMBO_PROFILE_ESTABLECIMIENTO_FAIL';

export const ORIGEN_LOGIN = 'ORIGEN_LOGIN';

// Acción de inicio de sesión de prueba
export const LOGIN_PRUEBA_REQUEST = 'LOGIN_LOGIN_PRUEBA_REQUESTREQUEST';
export const LOGIN_PRUEBA_SUCCESS = 'LOGIN_PRUEBA_SUCCESS';
export const LOGIN_PRUEBA_FAIL = 'LOGIN_PRUEBA_FAIL';

// Acción para refresh token
export const REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS';

// Acción para encriptar url para usarlo en doble factor
export const PARAMETROS_URL_REQUEST = 'PARAMETROS_URL_REQUEST';
export const PARAMETROS_URL_SUCCESS = 'PARAMETROS_URL_SUCCESS';
export const PARAMETROS_URL_FAIL = 'PARAMETROS_URL_FAIL';

export const DESENCRIPTA_URL_REQUEST = 'DESENCRIPTA_URL_REQUEST';
export const DESENCRIPTA_URL_SUCCESS = 'DESENCRIPTA_URL_SUCCESS';
export const DESENCRIPTA_URL_FAIL = 'DESENCRIPTA_URL_FAIL';
